import { render, staticRenderFns } from "./zunxiangCardList.vue?vue&type=template&id=1b62e8e2&scoped=true&"
import script from "./zunxiangCardList.vue?vue&type=script&lang=js&"
export * from "./zunxiangCardList.vue?vue&type=script&lang=js&"
import style0 from "./zunxiangCardList.vue?vue&type=style&index=0&id=1b62e8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b62e8e2",
  null
  
)

export default component.exports